export default "__VITE_PUBLIC_ASSET__757c3db6__"